import { useCallback, useSyncExternalStore } from 'react';
import type { AgentActivityEngine } from './AgentActivityEngine';
import type { ActivityRow } from './ActivityRow.utils';

/**
 * Reactively reads the derived Activity rows from the store. The store returns its rows by stable
 * reference, so the snapshot only changes identity when the rows actually change — no render storm.
 */
export const useActivityRows = (store: AgentActivityEngine): ReadonlyArray<ActivityRow> => {
  const subscribe = useCallback((listener: () => void) => store.subscribe(listener), [store]);
  return useSyncExternalStore(subscribe, () => store.getRows());
};
